import Contact from "../Components/Contact"
import Footer from "../Components/Footer"
import Navbar from "../Components/Navbar"

const ContactPage = () => {
  return (
    <div className="contact-page">
      <Navbar />
      <Contact />
      <Footer />
    </div>
  )
}

export default ContactPage
